import { c as r } from "./index-8b07dec9.js";
import t, { css as i } from "styled-components";
import { jsx as s } from "react/jsx-runtime";
var l = /* @__PURE__ */ t.div.withConfig({
  displayName: "accordionPanel__StyledAccordionPanel",
  componentId: "fzk45n-0"
})(["&.AccordionPanel{", ";}"], function(o) {
  var a = o.theme.components.accordion;
  return i(a.AccordionPanel);
}), p = function(a) {
  var n = a.children, e = a.className, c = a.dataTestId, d = c === void 0 ? "ACCORDION_PANEL_DATA_TEST_ID" : c;
  return /* @__PURE__ */ s(l, {
    className: r(["AccordionPanel", e]),
    "data-testid": d,
    children: n
  });
};
export {
  p as A
};
